
// import React, { useState, useEffect } from "react";
// import "./BrandList.css";
// import { fetchBrands, updateBrand } from "../services/brandService";

// function BrandList() {
//   const [brands, setBrands] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);

//   // Edit State
//   const [editingBrandId, setEditingBrandId] = useState(null);
//   const [editingBrandName, setEditingBrandName] = useState("");
//   const [savingBrand, setSavingBrand] = useState(false);

//   useEffect(() => {
//     loadBrands();
//   }, []);

//   const loadBrands = async () => {
//     try {
//       setLoading(true);
//       const data = await fetchBrands();
//       setBrands(Array.isArray(data) ? data : []);
//     } catch (err) {
//       console.error("Error fetching brands:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditBrand = (brand) => {
//     setEditingBrandId(brand.id);
//     setEditingBrandName(brand.brand_name || "");
//   };

//   const handleSaveBrand = async () => {
//     if (!editingBrandName.trim()) {
//       alert("Brand name cannot be empty.");
//       return;
//     }

//     try {
//       setSavingBrand(true);
//       await updateBrand(editingBrandId, editingBrandName.trim());

//       setBrands((prevBrands) =>
//         prevBrands.map((brand) =>
//           brand.id === editingBrandId
//             ? { ...brand, brand_name: editingBrandName.trim() }
//             : brand
//         )
//       );

//       setEditingBrandId(null);
//       setEditingBrandName("");
//     } catch (error) {
//       console.error("Error updating brand:", error);
//       alert(error.message || "Failed to update brand.");
//     } finally {
//       setSavingBrand(false);
//     }
//   };

//   const filteredBrands = brands.filter((brand) =>
//     brand.brand_name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="brand-list-container">
//       <header className="admin-header">
//         <div>
//           <h1>Brand Management</h1>
//           <p className="admin-subtitle">View and search registered brands</p>
//         </div>
//       </header>

//       <div className="admin-actions">
//         <h2>Brand Directory</h2>
//         <input
//           type="text"
//           className="search-input"
//           placeholder="Search brands..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <p>Loading brands...</p>
//       ) : (
//         <table className="admin-table">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Brand Name</th>
//               <th>Image</th>
//               <th>Created At</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredBrands.length === 0 ? (
//               <tr>
//                 <td colSpan="5" className="table-empty">
//                   No brands found.
//                 </td>
//               </tr>
//             ) : (
//               filteredBrands.map((brand) => (
//                 <tr key={brand.id}>
//                   <td>{brand.id}</td>

//                   <td className="font-medium">
//                     {editingBrandId === brand.id ? (
//                       <input
//                         type="text"
//                         value={editingBrandName}
//                         onChange={(e) => setEditingBrandName(e.target.value)}
//                         className="edit-input"
//                       />
//                     ) : (
//                       brand.brand_name
//                     )}
//                   </td>

//                   <td>
//                     {brand.logo ? (
//                       <img
//                         src={brand.logo}
//                         alt={`${brand.brand_name} logo`}
//                         className="brand-logo-thumbnail"
//                       />
//                     ) : (
//                       "-"
//                     )}
//                   </td>

//                   <td>
//                     {brand.created_at
//                       ? new Date(brand.created_at).toLocaleDateString("en-IN")
//                       : "-"}
//                   </td>

//                   <td>
//                     {editingBrandId === brand.id ? (
//                       <>
//                         <button
//                           type="button"
//                           onClick={handleSaveBrand}
//                           disabled={savingBrand}
//                           className="save-btn"
//                         >
//                           {savingBrand ? "Saving..." : "Save"}
//                         </button>
//                         <button
//                           type="button"
//                           onClick={() => {
//                             setEditingBrandId(null);
//                             setEditingBrandName("");
//                           }}
//                           className="cancel-btn"
//                         >
//                           Cancel
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         type="button"
//                         onClick={() => handleEditBrand(brand)}
//                         className="edit-btn"
//                         title="Edit Brand"
//                       >
//                         ✏️
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }

// export default BrandList;

import React, { useState, useEffect } from "react";
import "./BrandList.css";
import { fetchBrands, updateBrand } from "../services/brandService";

function BrandList() {
  const [brands, setBrands] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  // Edit State
  const [editingBrandId, setEditingBrandId] = useState(null);
  const [editingBrandName, setEditingBrandName] = useState("");
  const [editingBrandLogo, setEditingBrandLogo] = useState(null);
  const [editingBrandLogoPreview, setEditingBrandLogoPreview] = useState(null);
  const [savingBrand, setSavingBrand] = useState(false);

  useEffect(() => {
    loadBrands();
  }, []);

  const loadBrands = async () => {
    try {
      setLoading(true);
      const data = await fetchBrands();
      setBrands(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching brands:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEditBrand = (brand) => {
    setEditingBrandId(brand.id);
    setEditingBrandName(brand.brand_name || "");
    setEditingBrandLogo(null);
    setEditingBrandLogoPreview(brand.logo || null);
  };

  const handleEditLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setEditingBrandLogo(file);
    setEditingBrandLogoPreview(URL.createObjectURL(file));
  };

  const handleCancelEdit = () => {
    setEditingBrandId(null);
    setEditingBrandName("");
    setEditingBrandLogo(null);
    setEditingBrandLogoPreview(null);
  };

  const handleSaveBrand = async () => {
    if (!editingBrandName.trim()) {
      alert("Brand name cannot be empty.");
      return;
    }

    try {
      setSavingBrand(true);
      const updatedBrand = await updateBrand(
        editingBrandId,
        editingBrandName.trim(),
        editingBrandLogo
      );

      setBrands((prevBrands) =>
        prevBrands.map((brand) =>
          brand.id === editingBrandId
            ? {
                ...brand,
                brand_name: editingBrandName.trim(),
                logo: updatedBrand.logo || brand.logo,
              }
            : brand
        )
      );

      handleCancelEdit();
    } catch (error) {
      console.error("Error updating brand:", error);
      alert(error.message || "Failed to update brand.");
    } finally {
      setSavingBrand(false);
    }
  };

  const filteredBrands = brands.filter((brand) =>
    brand.brand_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="brand-list-container">
      <header className="admin-header">
        <div>
          <h1>Brand Management</h1>
          <p className="admin-subtitle">View and search registered brands</p>
        </div>
      </header>

      <div className="admin-actions">
        <h2>Brand Directory</h2>
        <input
          type="text"
          className="search-input"
          placeholder="Search brands..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {loading ? (
        <p>Loading brands...</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Brand Name</th>
              <th>Image</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredBrands.length === 0 ? (
              <tr>
                <td colSpan="5" className="table-empty">
                  No brands found.
                </td>
              </tr>
            ) : (
              filteredBrands.map((brand) => (
                <tr key={brand.id}>
                  <td>{brand.id}</td>

                  <td className="font-medium">
                    {editingBrandId === brand.id ? (
                      <input
                        type="text"
                        value={editingBrandName}
                        onChange={(e) => setEditingBrandName(e.target.value)}
                        className="edit-input"
                      />
                    ) : (
                      brand.brand_name
                    )}
                  </td>

                  <td>
                    {editingBrandId === brand.id ? (
                      <div>
                        <input
                          type="file"
                          accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml"
                          onChange={handleEditLogoChange}
                        />
                        {editingBrandLogoPreview && (
                          <div style={{ marginTop: "8px" }}>
                            <img
                              src={editingBrandLogoPreview}
                              alt="Logo Preview"
                              className="brand-logo-thumbnail"
                            />
                          </div>
                        )}
                      </div>
                    ) : brand.logo ? (
                      <img
                        src={brand.logo}
                        alt={`${brand.brand_name} logo`}
                        className="brand-logo-thumbnail"
                      />
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>
                    {brand.created_at
                      ? new Date(brand.created_at).toLocaleDateString("en-IN")
                      : "-"}
                  </td>

                  <td>
                    {editingBrandId === brand.id ? (
                      <>
                        <button
                          type="button"
                          onClick={handleSaveBrand}
                          disabled={savingBrand}
                          className="save-btn"
                        >
                          {savingBrand ? "Saving..." : "Save"}
                        </button>
                        <button
                          type="button"
                          onClick={handleCancelEdit}
                          className="cancel-btn"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={() => handleEditBrand(brand)}
                        className="edit-btn"
                        title="Edit Brand"
                      >
                        ✏️
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default BrandList;